export const ChatApiRoutes = {
  TwilioService: {
    Get: (tenantId: string, conversationId: string, userId: string, limit?: number): string =>
      limit
        ? `acs/chat-handler/tenants/${tenantId}/conversations/${conversationId}/messages?userId=${userId}&limit=${limit}`
        : `acs/chat-handler/tenants/${tenantId}/conversations/${conversationId}/messages?userId=${userId}`,
    Post: (tenantId: string, conversationId: string, userId: string): string =>
      `acs/chat-handler/tenants/${tenantId}/conversations/${conversationId}/messages?userId=${userId}`,
    LastIndexRead: (tenantId: string, conversationId: string, userId: string): string =>
      `acs/chat-handler/tenants/${tenantId}/conversations/${conversationId}/last-read-message-index?userId=${userId}`,
    SaveDraft: (tenantId: string, conversationId: string, userId: string): string =>
      `acs/chat-handler/tenants/${tenantId}/conversations/${conversationId}/draft?userId=${userId}`,
    MediaPolicy: (tenantId: string, conversationId: string, userId: string, limit: number): string =>
      `acs/chat-handler/tenants/${tenantId}/conversations/${conversationId}/media-policy?userId=${userId}&limit=${limit}`,
    Media: (tenantId: string, conversationId: string, userId: string): string =>
      `acs/chat-handler/tenants/${tenantId}/conversations/${conversationId}/messages/media?userId=${userId}`,
  },
};
